import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent implements OnInit {
  isLoading: boolean;
  constructor(private readonly loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.isLoading.subscribe((newValue) => (this.isLoading = newValue));
  }
}
